module.exports = __webpack_public_path__ + "static/media/skills_logo.a2e540d4.png";